<template>
    <div class="badges-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Default Badges</h3>
                </div>

                <h1>Example heading <span class="badge bg-secondary">New</span></h1>
                <h2>Example heading <span class="badge bg-secondary">New</span></h2>
                <h3>Example heading <span class="badge bg-secondary">New</span></h3>
                <h4>Example heading <span class="badge bg-secondary">New</span></h4>
                <h5>Example heading <span class="badge bg-secondary">New</span></h5>
                <h6>Example heading <span class="badge bg-secondary">New</span></h6>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Button Badges</h3>
                </div>

                <button type="button" class="btn btn-primary">
                    Notifications <span class="badge text-bg-secondary">4</span>
                </button>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Positioned Badges</h3>
                </div>

                <button type="button" class="btn btn-primary position-relative">
                    Inbox
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                        99+
                        <span class="visually-hidden">unread messages</span>
                    </span>
                </button>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Profile Status</h3>
                </div>

                <button type="button" class="btn btn-primary position-relative">
                    Profile
                    <span class="position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle">
                        <span class="visually-hidden">New alerts</span>
                    </span>
                </button>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Background Color Badges</h3>
                </div>

                <span class="badge text-bg-primary me-1">Primary</span>
                <span class="badge text-bg-secondary me-1">Secondary</span>
                <span class="badge text-bg-success me-1">Success</span>
                <span class="badge text-bg-danger me-1">Danger</span>
                <span class="badge text-bg-warning me-1">Warning</span>
                <span class="badge text-bg-info me-1">Info</span>
                <span class="badge text-bg-light me-1">Light</span>
                <span class="badge text-bg-dark me-1">Dark</span>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Pill badges</h3>
                </div>

                <span class="badge rounded-pill text-bg-primary me-1">Primary</span>
                <span class="badge rounded-pill text-bg-secondary me-1">Secondary</span>
                <span class="badge rounded-pill text-bg-success me-1">Success</span>
                <span class="badge rounded-pill text-bg-danger me-1">Danger</span>
                <span class="badge rounded-pill text-bg-warning me-1">Warning</span>
                <span class="badge rounded-pill text-bg-info me-1">Info</span>
                <span class="badge rounded-pill text-bg-light me-1">Light</span>
                <span class="badge rounded-pill text-bg-dark me-1">Dark</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BadgesContent'
}
</script>